import React from 'react'
import Navigationbar from '../Navbar/Navigationbar'
import Services from '../Services/Services';
import Customers from '../Customers/Customers';
import AboutUs from '../AboutUs/AboutUs';
import HomeScreen from '../HomeScreen/HomeScreen';
import ContactUs from '../ContactUs/ContactUs';
import { Advertisement } from '../AdvertisementBar/Advertisement';
import Footer from '../Footer/Footer';
import './HomePage.css'; // Import your custom CSS for styling
import NewsandUpdates from '../NewsandUpdates/NewsandUpdates';
import Gallery from '../Gallery/Gallery';
// import { Alert } from 'react-bootstrap';

const HomePage = () => {
    return (
        <div className='Home-bg'>
            <Navigationbar />
            <Advertisement />
            <section id="home" >
                <HomeScreen />
            </section>
            <section id="services">
                <Services />
            </section>
            <section id="customers">
                <Customers />
            </section>
            <section id="gallery">
                <Gallery />
            </section>
            <section id="news">
                <NewsandUpdates />
            </section>
            <section id="about">
                <AboutUs />
            </section>
            <section id="contact">
                <ContactUs />
            </section>
            <section id="footer">
                <Footer />
            </section>

        </div>
    )
}

export default HomePage